import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";
import "./Cgu.css";
import Header from "../header/header";
import Footer from "../commun/Footer";

const CGV = () => (
  <>
    <Header />
    <Container maxWidth="md" className="cgu-container">
      <Box py={5}>
        <Typography variant="h4" align="center" gutterBottom>
          Conditions Générales de de Ventes (CGV)
        </Typography>

        <Typography
          variant="subtitle2"
          align="center"
          className="cgu-date"
          gutterBottom
        >
          Dernière mise à jour : [18/09/2025]
        </Typography>

        <Divider className="cgu-divider" />

        <Typography variant="h6" gutterBottom>
          1. Objet et champ d’application
        </Typography>
        <Typography paragraph>
          Les présentes Conditions Générales de Vente (CGV) définissent les
          modalités contractuelles applicables aux services payants proposés via
          la Plateforme{" "}
          <a
            href="https://cooptaleo.com/"
            style={{ textDecoration: "underline", color: "blue" }}
          >
            cooptaleo.com
          </a>
          , exploitée par CIT MENA INFORMATION TECHNOLOGY CONSULTANCY (ci-après
          « l’Éditeur »).
        </Typography>
        <Typography paragraph>Elles s’appliquent :</Typography>
        <ul className="cgu-list">
          <li>aux entreprises clientes publiant des besoins de recrutement IT ;</li>
          <li>
            aux recruteurs indépendants partenaires percevant des commissions de
            succès via la Plateforme.
          </li>
        </ul>
        <Typography paragraph>
          Toute utilisation de services payants vaut acceptation pleine et
          entière des présentes CGV.
        </Typography>

        <Typography variant="h6" gutterBottom>
          2. Prestations proposées
        </Typography>

        <Typography fontWeight="bold">Inscription</Typography>
        <Typography paragraph>
          L’inscription et la création d’un compte (Entreprise ou Recruteur) sur
          la Plateforme sont gratuites.
        </Typography>

        <Typography fontWeight="bold">Pour les entreprises</Typography>
        <ul className="cgu-list">
          <li>Publication de besoins en recrutement IT,</li>
          <li>
            Réception et consultation de profils candidats proposés par les recruteurs,
          </li>
          <li>Accès aux outils de suivi et reporting des candidatures,</li>
          <li>Accompagnement optionnel (selon offre souscrite).</li>
        </ul>

        <Typography fontWeight="bold">Pour les recruteurs indépendants</Typography>
        <ul className="cgu-list">
          <li>Accès à des besoins qualifiés IT publiés par les entreprises,</li>
          <li>Possibilité de proposer des candidats,</li>
          <li>
            Rémunération par commission en cas de recrutement effectif d’un candidat proposé.
          </li>
        </ul>

        <Typography paragraph>
          L’Éditeur se réserve le droit de modifier les services, fonctionnalités
          et tarifs à tout moment.
        </Typography>

        <Typography variant="h6" gutterBottom>
          3. Conditions financières
        </Typography>

        <Typography fontWeight="bold">Pour les entreprises</Typography>
        <Typography paragraph>
          Les tarifs des prestations payantes (frais de succès, services premium,
          accompagnements spécifiques) sont communiqués au moment de la commande
          ou de la souscription. Les prix sont exprimés en euros (EUR) et
          s’entendent hors taxes. Des frais additionnels peuvent s’appliquer pour
          des services optionnels clairement identifiés.
        </Typography>

        <Typography fontWeight="bold">Pour les recruteurs indépendants</Typography>
        <Typography paragraph>
          La rémunération prend la forme d’une commission de succès, calculée en
          pourcentage du montant convenu avec l’entreprise (salaire brut annuel
          du candidat recruté, TJM ou forfait selon le type de mission). Le
          pourcentage et les modalités de calcul sont précisés dans l’espace
          recruteur et/ou dans la documentation contractuelle associée. Aucun
          paiement n’est dû si le candidat proposé n’est pas effectivement
          recruté.
        </Typography>

        <Typography variant="h6" gutterBottom>
          4. Modalités de paiement
        </Typography>
        <Typography paragraph>
          Les factures entreprises sont émises à la date de validation de la
          prestation et sont payables sous 30 jours fin de mois, sauf
          stipulation contraire. Les paiements s’effectuent en euros (EUR) par
          virement bancaire ou par tout autre moyen accepté par l’Éditeur. En
          cas de retard, des pénalités de retard seront appliquées conformément à
          la législation en vigueur.
        </Typography>

        <Typography variant="h6" gutterBottom>
          5. Rémunération des recruteurs indépendants
        </Typography>
        <Typography paragraph>
          La commission est due uniquement lorsque l’entreprise cliente conclut
          un contrat de travail ou de prestation avec un candidat présenté via la
          Plateforme. Le versement est effectué par virement bancaire en euros
          (EUR) dans un délai de 30 jours suivant la confirmation du recrutement
          par l’entreprise et le règlement effectif de la facture correspondante.
          En cas de litige (profil déjà connu de l’entreprise, informations
          erronées, fraude), l’Éditeur se réserve le droit de suspendre ou
          d’annuler la rémunération.
        </Typography>

        <Typography variant="h6" gutterBottom>
          6. Obligations des parties
        </Typography>

        <Typography fontWeight="bold">Obligations de l’Éditeur</Typography>
        <ul className="cgu-list">
          <li>Assurer l’accès à la Plateforme et aux services souscrits,</li>
          <li>
            Mettre en œuvre les moyens nécessaires pour garantir la sécurité et la
            confidentialité des données,
          </li>
          <li>Verser les commissions dues aux recruteurs dans les délais convenus.</li>
        </ul>

        <Typography fontWeight="bold">Obligations des entreprises</Typography>
        <ul className="cgu-list">
          <li>Fournir des informations exactes lors de la publication de besoins,</li>
          <li>Respecter les délais de paiement,</li>
          <li>
            Informer Cooptaleo de tout recrutement conclu avec un candidat présenté via
            la Plateforme.
          </li>
        </ul>

        <Typography fontWeight="bold">Obligations des recruteurs</Typography>
        <ul className="cgu-list">
          <li>
            Proposer uniquement des candidats réels, disponibles et informés de la
            démarche,
          </li>
          <li>Respecter la confidentialité des informations communiquées,</li>
          <li>Ne pas détourner les candidatures en dehors de la Plateforme.</li>
        </ul>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h6" gutterBottom>
          7. Durée et résiliation
        </Typography>
        <Typography paragraph>
          Les CGV s’appliquent pendant toute la durée d’utilisation des services
          payants de la Plateforme. Chaque partie peut résilier le contrat en cas
          de manquement grave de l’autre partie, sous réserve d’un préavis de 15
          jours après mise en demeure restée sans effet. La résiliation ne
          dispense pas les entreprises du paiement des factures émises ni
          l’Éditeur du versement des commissions dues.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h6" gutterBottom>
          8. Responsabilité et garanties
        </Typography>
        <Typography paragraph>
          L’Éditeur agit comme intermédiaire technique et ne garantit pas la
          conclusion effective d’un recrutement ni la qualité professionnelle des
          candidats proposés. L’Éditeur n’est responsable que des dommages directs
          et prouvés, dans la limite du montant payé par l’entreprise ou de la
          commission due au recruteur. En aucun cas l’Éditeur ne peut être tenu
          responsable des pertes indirectes (perte de chiffre d’affaires, perte de
          chance, etc.).
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h6" gutterBottom>
          9. Confidentialité
        </Typography>
        <Typography paragraph>
          Toutes les informations échangées via la Plateforme (besoins, profils
          candidats, contrats, etc.) sont strictement confidentielles. Chaque
          partie s’engage à ne pas divulguer ces informations sans accord écrit
          préalable.
        </Typography>

        <Typography variant="h6" gutterBottom>
          10. Données personnelles
        </Typography>
        <Typography paragraph>
          Le traitement des données personnelles est régi par la Politique de
          confidentialité (RGPD) disponible à l’adresse suivante :{" "}
          <a
            href="https://cooptaleo.com/confidentiality"
            style={{ textDecoration: "underline", color: "blue" }}
          >
            https://cooptaleo.com/confidentiality
          </a>
        </Typography>

        <Typography variant="h6" gutterBottom>
          11. Force majeure
        </Typography>
        <Typography paragraph>
          L’Éditeur ne pourra être tenu responsable en cas de manquement ou de
          retard lié à un événement constitutif de force majeure au sens de la loi
          et de la jurisprudence applicable.
        </Typography>

        <Typography variant="h6" gutterBottom>
          13. Juridiction compétente
        </Typography>
        <Typography paragraph>
          En cas de litige, les tribunaux compétents seront ceux du ressort du
          siège social de l’Éditeur, sauf dispositions légales impératives
          contraires.
        </Typography>
      </Box>
    </Container>
    <Footer />
  </>
);

export default CGV;
